// import {BASEURL} from "@/http/const";
// const baseUrl="https://app005.downline.cn"
// let host = window.location.origin;// window.location.host;
let host = 'http://www.duzikai.com/';// window.location.host;
let imgUrl = `${host}`
const getImgCodeUrl = (length = 4) => {
    let dtNow = new Date().getTime();
    let url = `${imgUrl}/duzikai_api_mgr_image_code.png?invoke_method=public_page_4m_random_code&pre_db_para_length_4_list=${length}&t=${dtNow}`;
    return { url, dtNow };
}

export default {
    getImgCodeUrl
}
